import React, { FC } from 'react';

import { LinkList } from '@eika/link-list';

import { useConfig } from '../../defaultConfig';
import useTranslation from '../../hooks/useTranslation';
import { settingsTrackIDs } from '../../utils/gtm/trackIDs/settings';
import EFakturaAccountButton from '../EFakturaAccountModal/EFakturaAccountButton';
import UpdateEFakturaAgreement from './UpdateEFakturaAgreement';

const EfakturaAgreement: FC = () => {
    const { efakturaNotificationsLink, shareEfakturaLink, featureToggles } = useConfig();
    const translated = useTranslation();

    return (
        <>
            <UpdateEFakturaAgreement />
            <EFakturaAccountButton />
            {efakturaNotificationsLink?.url && !featureToggles.disableEfakturaNotifications && (
                <LinkList.Item
                    href={efakturaNotificationsLink.url}
                    data-track-id={settingsTrackIDs.efakturaLink}
                    data-track-linkname={translated.eFakturaAgreement.notificationsLink}
                >
                    {translated.eFakturaAgreement.notificationsLink}
                </LinkList.Item>
            )}
            {shareEfakturaLink?.url && featureToggles.enableShareEfaktura && (
                <LinkList.Item
                    href={shareEfakturaLink.url}
                    data-track-id={settingsTrackIDs.efakturaLink}
                    data-track-linkname={translated.eFakturaSharing.shareEfaktura}
                >
                    {translated.eFakturaSharing.shareEfaktura}
                </LinkList.Item>
            )}
        </>
    );
};

export default EfakturaAgreement;
